package com.schoolconnect.app.feature.common

data class ClassSectionFilterChoice(
    val label: String,
    val className: String,
    val sectionName: String
)

fun buildClassSectionFilterChoices(
    classNames: List<String>,
    sectionsByClass: Map<String, List<String>>
): List<ClassSectionFilterChoice> = buildList {
    classNames.forEach { className ->
        sectionsByClass[className].orEmpty().forEach { section ->
            add(ClassSectionFilterChoice("$className - $section", className, section))
        }
    }
}.distinctBy { it.label }

fun selectedClassSectionFilterLabel(
    className: String,
    sectionName: String,
    choices: List<ClassSectionFilterChoice>
): String = choices.firstOrNull {
    it.className == className && it.sectionName == sectionName
}?.label.orEmpty()
